var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtBurgerGroBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 353.3 183.7",
    style: {
      enableBackground: "new 0 0 353.3 183.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{fill:#262324;}\n\t.st3{display:inline;fill:#262324;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ANTI_x5F_white_x5F_alier",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.1,171.8l-23.2-11.6V75.4L167.4,64v-8h-28.5V27.9h-14.5l-9.2,34.3v56.5l0,0c-0.3,15.3-5.6,28.1-15.5,37.2 c-9.8,9-23.1,13.4-36.7,12.3c-22.1-2.2-37.5-19.5-37.5-42.1c0-12.7,6.8-25.4,17.7-33c11.6-8.1,26.1-9.6,40.9-4.4l7.5-9.5L36.7,27.9 h49.9L96,61h8.5V6.4H12.4v22l52.1,43.5L61,71.4c-0.6-0.1-1-0.1-1-0.1c-2.7-0.3-5.3-0.5-7.8-0.5c-16,0-27,6.6-33.8,12.6 C6.9,93.5,0,108.9,0,124.3c0,15.6,6.2,30,17.5,40.8c11.6,11,27.8,17.2,45.6,17.5c32.9,0.4,49.9-20.5,58.4-38.1l0.4-0.9l11.7,6.3 l-16.3,30.2H162v-8.3L162.1,171.8L162.1,171.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "GRO_x5F_black_x5F_Et"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M172,55.4h-31.8V29.6h-25.3l0,0l0,0v66.3c0,38.6-15.7,65.6-50.6,66c-20.9,0-39.3-14.1-39-37.8 c0.4-29.6,27.5-46.5,60-34.5l10.2-13.3L41.2,29.5h73.5V6.4H10.5v23.8l45.9,39.2C21.3,66,0,96.4,0,123.9c0,31.8,24.6,58.5,61.2,58.7 c24.9,0.1,41.5-11.1,52-26.2h1.6V180h25.3V77.2H172V55.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ANTI_x5F_black_x5F_et",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.7,76.2l28.5-11.4v-9.7h-28.5V55V29h-16.2l-9.4,33.1v55.4l0,0c0,35-26.7,51.8-51.2,49.8 c-21-2.1-36.6-18.5-36.6-41.1c0-24.2,25-48.3,57.9-36.2l0,0l0,0l0,0l0,0l8.4-10.8L41,29h46.7l9.4,33.1h9.5V5.5H13.2V29L63,70.6 c-0.7-0.1-1-0.1-1-0.1c-38-4.9-61.2,25.7-61.2,54c0,32.2,26.1,58.7,64.1,59.2c34.1,0.5,51.2-21.7,59.3-38.7l9.9,5.3L117.5,181h47.3 v-9.8l-23.1-11.5v-83L141.7,76.2L141.7,76.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 55.5,
    className: "st2",
    width: 146.5,
    height: 21.8
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 106.8,
    className: "st2",
    width: 146.5,
    height: 21.8
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 158,
    className: "st2",
    width: 146.5,
    height: 21.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st4",
    width: 353.3,
    height: 183.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtBurgerGroBlack);
export default __webpack_public_path__ + "static/media/et-burger-gro-black.2a1c4f236ccec94e598e8cbcba31e083.svg";
export { ForwardRef as ReactComponent };